import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-store-warehouses',
  templateUrl: './store-warehouses.component.html',
  styleUrls: ['./store-warehouses.component.css']
})
export class StoreWarehousesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
